import { Component, OnInit } from '@angular/core';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

import { OpEnum } from '../../../shared/enums/op.enum';
import { LottieImage } from '../../../shared/models/abre-cuentas.model';
import { ExternalResponse } from '../../../shared/models/channel-communicator/external-response.model';
import { CheckboxModel } from '../../../shared/models/common.model';
import { DocumentModel } from '../../../shared/models/document.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import {
  ChannelCommunicatorService,
} from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { IdentificationService } from '../../../shared/services/identification/identification.service';
import { BackDocumentScanImage } from './back-document-scan-image';

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-back-document-scan',
  templateUrl: './back-document-scan.component.html',
  styleUrls: ['./back-document-scan.component.scss'],
})

/**
 * Definición de la clase DocumentScanSuccessComponent, escaneo de la parte de atrás del documento
 *
 * *Defines DocumentScanSuccessComponent class, back scan document*
 */
export class BackDocumentScanComponent implements OnInit {

  /**
   * Variable de validación para mostrar modal
   *
   * *Validation variable to showModal*
   *
   * @access public
   * @type {boolean}
   */
  showModal = false;

  /**
   * Copies de los labels del modal
   *
   * *Labels modal copies*
   *
   * @access public
   * @type {Object}
   */
  buttonLabelsModal = {};

  /**
   * Variable de validación de términos y condiciones
   *
   * *Validation variable to terms and conditions*
   *
   * @access public
   * @type {any}
   */
  terms: any;

  /**
   * Variable de validación de términos y condiciones
   *
   * *Validation variable to terms and conditions*
   *
   * @access public
   * @type {DocumentModel}
   */
  documenInfo: DocumentModel;

  /**
   * Variable de validación de botón habilitado
   *
   * *Validation variable to disable button*
   *
   * @access public
   * @type {boolean}
   */
  isBtnDisabled = true;

  /**
   * Variable de CheckBox de términos y condiciones
   *
   * *CheckBox variable to terms and conditions*
   *
   * @access public
   * @type {CheckboxModel}
   */
  checkboxTerms: CheckboxModel;

  /**
   * Variable de cantidad máxima de intentos para escanear imagen
   *
   * *Max scan attempts variable to scan image*
   *
   * @access public
   * @type {number}
   */
  maxScanAttempts: number;

  /**
   * Variable para la respuesta externa del servicio de escaner
   *
   * *External response variable of the scanning service*
   *
   * @access public
   * @type {ExternalResponse}
   */
  scanResponse: ExternalResponse;

  /**
   * Variable para la imagen
   *
   * *Variable for the image*
   *
   * @access public
   * @type {boolean}
   */
  image: LottieImage;

  /**
   * Summary Constructor of the component.
   *
   * @param {HeaderService}              headerService              Injectable headerService service.
   * @param {AbreCuentasService}         abreCuentasService         Injectable abreCuentasService service.
   * @param {IdentificationService}      identificationService      Injectable identificationService service.
   * @param {ChannelCommunicatorService} channelCommunicatorService Injectable channelCommunicatorService service.
   * @param {ParametersService}          ParametersService          Injectable parametersServices service
   * @function headerService.show(true,true)
   */
  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private identificationService: IdentificationService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private parametersService: ParametersService,
    private navigationService: NavigationService,
    private taggingServices: TaggingService,
    private loaderService: LoaderService,
    private bitacoraService: BitacoraService,
  ) {
    this.headerService.show(true, true, true);
    this.buttonLabelsModal = {
      primary: copyService.copies.back_document_modal_button_primary,
    };
  }

  /**
   * Configuracion de imagen, términos y condiciones y máximo intentos de escaner
   * en el momento que el componente es montado
   *
   * *Image, terms and conditions and max scan attempts config once the component is mount*
   */
  ngOnInit() {
    this.image = {
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: BackDocumentScanImage,
    };
    this.terms = {
      text: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].description,
      title: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].code,
      terms_id: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].id,
    };
    this.checkboxTerms = {
      id: this.terms.terms_id,
      label: 'Autorizo el tratamiento de mis datos según la siguiente política: ',
      checked: false,
      value: this.terms.terms_id,
    };
    this.maxScanAttempts = this.abreCuentasService.getBytteConfig().failedAttempts.backDocumentScan;
  }

  // /**
  //  * Acción del modal
  //  *
  //  * *Modal action*
  //  *
  //  * @param event
  //  * @type {function}
  //  */
  // modalAction(event) {
  //   if (event.type === 'primary') {
  //     this.downloadPdf();
  //   }
  // }

  async next() {
    // this.loaderService.show();
    this.sendTagging('next', 'bottom', '2');
    const bitacoraEvent = 'term_condition_accept';
    this.identificationService.backDocumentScan().then(
      response => {
        this.identificationService.callbackBackDocumentScan(response);
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
      }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  sendTagging(value: any, position?: string, event?: string, extras?: any) {
    const page = '30';
    this.taggingServices.sendTaggValues(value, page, position, event, extras);
  }

  /**
   * Servicio para enviar datos a Google analytics
   *
   * *Send data to Google Analytics*
   */
  toggleModal() {
    // this.downloadPdf();
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionDetailsProductcategory`].path,
          value: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionDetailsProductcategory`].value,
        },
        {
          path: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`].path,
          value: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.link,
          position: EVENT.customCategory.position.top,
        },
        action: EVENT.customAction.click,
        label: EVENT[`${tagPageName}E1customLabel`],
      };
      this.taggingServices.pageTagEvent(event, changes);
    } catch (error) {
      console.log(`Error en: ${error}`);
    }
    this.showModal = !this.showModal;
    if (this.showModal) {
      this.navigationService.pageLoadTag(false, ['pv5', 'pv109', 'pv69', '']);
    }
  }

  /**
   * Evento para cambiar el estado de checkbox y establece la propiedad
   *
   * *Summary Event to change checkbox and set Prop*
   *
   * @param {any} event
   */
  checkboxChange(event: any): void {
    this.checkboxTerms.checked = event.checked;
    this.abreCuentasService.setFiProperty('checkboxTerms', this.checkboxTerms);
    this.enableNextButton();
  }

  /**
   * Método para descargar el PDF
   *
   * *Method to download pdf*
   */
  downloadPdf() {
    this.channelCommunicatorService.getImpl().openPdf(this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].pdfUrl);
  }

  /**
   * Habilitar botón
   *
   * *Summary Enable the Button*
   */
  enableNextButton() {
    this.isBtnDisabled = !(this.abreCuentasService.getFiProperty('checkboxTerms').checked);
  }
}
